export default __webpack_public_path__ + "static/media/machu-picchu.0249d23bbae678cf17cbbd73f5c2ae17.jpg";